// Check if language switcher link has ?lang-unavail param

import ArrayFrom from 'array-from'
import qs from 'qs'
import { TweenMax } from 'gsap/all'
import Translations from './translations/index.js'

class LangSelector {
  constructor (selector) {
    this.translations = Translations
    this.el = selector
    
    this.items = ArrayFrom(this.el.querySelectorAll('a'))
    let loggedInEl = document.querySelector('body')
    let loggedIn = false
    if (loggedInEl.classList.contains('logged-in') === true) {
      loggedIn = true
    }
    let lhPrefLang = this.getCookie('lh_lang_preference') // Check if cookie exists
    if (lhPrefLang && lhPrefLang.includes('-')) { // remove local from langage preference cookie. e.g 'de-DE'
      lhPrefLang = lhPrefLang.substring( 0, lhPrefLang.indexOf( '-' ) )
    }

    let browserLang = navigator.language.toLowerCase() // Get browser language
    browserLang = browserLang.substring( 0, browserLang.indexOf( '-' ) ) // remove country code from browser language. e.g 'en-us' - remove '-us'
    let pageLang = document.querySelector('html').getAttribute('lang') // Get current Page language
    if (loggedIn === false && pageLang !== lhPrefLang) {
      this.showRecommendation(this.items, lhPrefLang, browserLang, pageLang) // Show recommendation page if exists
    }
    
    this.bind(this.items)
    this.checkNavigator()
  }

  alert (language) {
    var event = new CustomEvent('LanguageUnavailable', {
      detail: language,
    })
    document.dispatchEvent(event)
  }

  checkNavigator () {
    var params = qs.parse(location.search.replace('?', ''))
    if (params['lang-unavail']) {
      this.alert(params['lang-unavail'])
    }
  }

  bind (collection) {
    collection.forEach((item) => {
      item.addEventListener('click', (e) => {
        var request = item.getAttribute('href')
        let toLang = item.getAttribute('data-lang')
        if (request && request.indexOf('?lang-unavail=') === 0) {
          e.preventDefault()
          let language = request.replace('?lang-unavail=', '')
          this.alert(language)
        } else {
          this.setCookie('lh_lang_preference', toLang, 365, this.getDomain(document.domain))
        }
      })
    })
  }

  // Show language recommendation (If exists else display alert)
  showRecommendation (collection, lhPrefLang, browserLang, pageLang) {
    let langHref
    if (lhPrefLang) {
      collection.forEach((item) => {
        let itemLang = item.getAttribute('data-lang')
        if (lhPrefLang === itemLang) {
          langHref = item.getAttribute('href')
        }
      })
      if (lhPrefLang !== pageLang) {
        if (langHref) {
          if (langHref.indexOf('?lang-unavail=') === 0) {
            this.alert(lhPrefLang)
          } else {
        
            this.bindLangRecommendation(langHref, lhPrefLang, pageLang)
          }
        }
      } 
    } else { // First page visit, no lh_lang_preference cookie exist
      if (browserLang) {
        
        collection.forEach((item) => {
          let itemLang = item.getAttribute('data-lang')
          if (browserLang === itemLang) {
            langHref = item.getAttribute('href')
          }
        })
        if (browserLang !== pageLang) {
          if (langHref) {
            if (langHref.indexOf('?lang-unavail=') === 0) {
              this.alert(browserLang)
            } else {
              this.bindLangRecommendation(langHref, browserLang, pageLang)
            }
          }
        }
      }
    }
  }

  bindLangRecommendation (langHref, prefLang, pageLang) {
    let code
    console.log('prefLang', this.translations[prefLang])
    // Language recommendation
    if (window.innerWidth < 999) {
      // mobile modal
      let el = document.querySelector('.lang-recomm-mobile')
      code = `<div class="modal-lang-recomm active d-flex align-items-center"  id="lang-recomm" role="dialog" aria-labelledby="lang-recomm-title" tab-index="-1">
        <div class="modal-background"></div>
        <div class="modal-dialogue container container--sm px-5">
          <div class="card is-white">
            <div class="card-header px-2 border-0 bg-white">
              <button class="btn-close modal-close dismiss close" aria-label=${this.translations[prefLang].langRecommendation.close} data-toggle="dismiss" data-ol-has-click-handler=""><span aria-hidden="true">×</span></button>
            </div>
            <div class="card-body text-center small py-0 px-4">
              <p id="lang-recomm-body pb-0">${this.translations[prefLang].langRecommendation.title}</p>
            </div>
            <div class="card-footer d-flex justify-content-center border-0 bg-white text-center">
              <a role="button" class="btn btn-primary btn-sm text-white btn-navigate text-center" data-ol-has-click-handler>${this.translations[prefLang].langRecommendation.navigate}</a>
              <a role="button" class="btn btn-primary btn-sm text-white btn-close text-center" data-toggle="dismiss" data-ol-has-click-handler>${this.translations[prefLang].langRecommendation.close}</a>
            </div>
          </div>
        </div>
      </div>`

      el.innerHTML = code
      this.close(el.querySelectorAll('.btn-close'), el.querySelector('.modal-lang-recomm'), prefLang, pageLang)
      
    } else {
      let el = document.querySelector('.lang-recomm-desktop')
      // desktop popup
      code = `<span class="text-center card card--sm">
        <span class="icon-close btn-close">×</span>
        <p class="small pb-0 mt-1 mb-2">${this.translations[prefLang].langRecommendation.title}</p>
        <div class="card-footer p-0 d-flex justify-content-center border-0 bg-white">
          <a role="button" class="btn btn-primary btn-sm text-white btn-navigate">${this.translations[prefLang].langRecommendation.navigate}</a>
          <a role="button" class="btn btn-primary btn-sm text-white btn-close">${this.translations[prefLang].langRecommendation.close}</a>
        </div>
      </span>`

      TweenMax.from(el, 0.8, {
        top: 0,
        right: 30,
      })
      TweenMax.to(el, 0.8, {
        top: 70,
        right: 30,
      })
      el.innerHTML = code
      let elCard = el.querySelector('.card')
      this.close(el.querySelectorAll('.btn-close'), elCard, prefLang, pageLang)
    }

    // Yes button
    let yes = document.querySelector('.btn-navigate')
    yes.addEventListener('click', () => {
      if (!this.getCookie('lh_lang_preference')) {
        this.setCookie('lh_lang_preference', prefLang, 365, this.getDomain(document.domain))
      }
      window.location.href = langHref
    })
  }

  // No and Close buttons
  close (buttons, el, prefLang, pageLang) {
    let parent = document.querySelector('.lang-recomm')
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.setCookie('lh_lang_preference', pageLang, 365, this.getDomain(document.domain))
        if (el.classList.contains('active')) {
          el.classList.remove('active')
        } else {
          
          TweenMax.to(parent, 0.8, {
            top: 0,
            opacity: 0,
            duration: 3,
            onComplete: () => {
              el.remove()
            },
          })
        }
      })
    })

    // Hide the popup in 1min if no action
    window.setTimeout(() => { 
      if (pageLang !== prefLang && el) {
        this.setCookie('lh_lang_preference', pageLang, 365, this.getDomain(document.domain))
        if (el.classList.contains('active')) {
          el.classList.remove('active')
        } else {
          TweenMax.to(parent, 0.8, {
            opacity: 0,
            duration: 3,
            onComplete: () => {
              el.remove()
            },
          })
        }
      }
    }, 60000)
  }

  setCookie (cname, cvalue, exdays, domain) {
    let d = new Date()
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    let expires = 'expires=' + d.toUTCString()

    const secure = location.protocol === 'https:' ? 'Secure;' : '';
    const domainPart = domain ? `domain=${domain};` : '';
    
    document.cookie = `${cname}=${encodeURIComponent(cvalue)}; ${domainPart} ${expires}; path=/; ${secure} SameSite=Lax`;
  }

  getCookie (cname) {
    var name = cname + '='
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length)
        }
    }
    return null
  }

  getDomain (url) {
    return url.replace(/^(?:https?:\/\/)?(?:[^/]+\.)?([^./]+\.[^./]+).*$/, '$1')
  }
}

const selectors = ArrayFrom(document.querySelectorAll('.language-switcher'))
selectors.forEach((selector) => {
  new LangSelector(selector)
})



// WEBPACK FOOTER //
// ./scripts/routes/langSwitcher.js